import * as z from "zod";

export const verificationErrorResponse = z.object({
  code: z.enum(["50119", "50067"]),
});
